import { render, staticRenderFns } from "./AcceptIcon.vue?vue&type=template&id=6f07dca1&scoped=true&"
import script from "./AcceptIcon.vue?vue&type=script&lang=js&"
export * from "./AcceptIcon.vue?vue&type=script&lang=js&"
import style0 from "./AcceptIcon.vue?vue&type=style&index=0&id=6f07dca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07dca1",
  null
  
)

export default component.exports